export const DEMOGRAPHICS_CONSTANTS = {
  ROUTES: {
    MAIN: 'demographics',
    FORMS: {
      WHEEL_OF_FORTUNE: 'wheel',
    },
  },
};
